import axios from "axios"

export const api = axios.create({
  // baseURL: "http://localhost:5058/",
  // baseURL: "https://sistema.miltecti.com.br/milshoapi/",
  baseURL: "https://hom.miltecti.com.br/milshopapi/",
})

export const getToken = () => {
  return localStorage.getItem('tokenString');
};

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);